export default "__VITE_ASSET__CDnggM5F__"